/**
 * Where a Fundamental's Notes and last-updated stamp are surfaced.
 *
 * Flip a flag to add or remove a surface; nothing else needs to change. Every listed
 * surface reads its own flag, including `notes.sharedVp`, which ships off but is wired
 * up so turning it on actually works. `lastUpdated` has no `sharedVp` entry because that
 * table carries no stamp to gate.
 *
 * Note there is deliberately no `notes.editForm` flag: the Notes textarea is always
 * rendered on the create/edit form. A flag able to hide the only input would make
 * already-stored notes unreachable.
 */
export const FUNDAMENTAL_DISPLAY = {
  notes: { listCard: true, vpDetailsRow: true, sharedVp: false },
  lastUpdated: { editForm: true, listCard: true, vpDetailsRow: true },
};
